// Classes
window.Utils   = require('./classes/Utils.js');
window.Leasing = require('./classes/Leasing.js');
window.CartItems = require('./classes/CartItems.js');
window.CompareItems = require('./classes/CompareItems.js');

require('./ui/common.js');
require('./ui/listing.js');
require('./ui/static-forms.js');
require('./ui/swiper_init.js');
require('./ui/popup.js');
require('./ui/ajax-forms.js');
require('./ui/product-gallery.js');
require('./ui/tabs.js');
require('./ui/product.js');
require('./ui/cart.js');
require('./ui/compare.js');
require('./ui/tracking.js');
require('./ui/sharing.js');
require('./ui/favourite-products.js');


// Init classes
Popup.init();
CartItems.init();
CompareItems.init();

Vue.filter("format_money", function(money) {
	var number = (typeof money === "number") ? money : +money.replace(/[^\d.,]/g, '');
	money = isNaN(number) ? 0 : number.toFixed(2);
	money = ("" + money).replace("\.", ".");

	return money;
});

Vue.prototype.$eventBus = new Vue();

// Init Vue components
Vue.component(
	'cart-products' , 
	require('./components/CartProducts.vue').default
);

Vue.component(
    'product-search',
    require('./components/Search.vue').default
);

Vue.component(
    'product-leasing',
    require('./components/Leasing.vue').default
);

Vue.component(
    'agree-checkbox',
    require('./components/AgreeCheckbox.vue').default
);

var SearchVue = new Vue({
	el: ".header__search"
});

if (document.getElementById("agree-checkbox")) {
	var AgreeCheckbox = new Vue({
		el: "#agree-checkbox",

		data: {
			bnpCheckedShown: false,
			bnpChecks: []
		},

		mounted: function() {
			this.$on("checked-credit-conditions", function(e) {
				this.bnpChecks.push(e);
			});

			this.$on("checkedPersonalDataInfo", function(e) {
				this.bnpChecks.push(e);
			});
		},

		created() {
			this.$root.$on('check-selected-company', data => {
				console.log(data);
				this.bnpCheckedShown = true;
				
			});
		},
	});
}

if (document.getElementById("cart-product-leasing")) {
	var CartProductLeasing = new Vue({
		el: "#cart-product-leasing",
		
		data: {
			price: 0
		},

		methods: {
			setPrice(price) {
				this.price = price;
			},

			
		}
	});
}

// Instantiate component only if the element exists
if (document.getElementById("cart-products")) 
{
	var CartProducts = new Vue({
		el: '#cart-products',

		beforeCreate: function() {
			this.$on("change-total-price", function(newTotal) {
				
				CartProductLeasing.setPrice(newTotal);

				// Minimum leasing price
				if (newTotal < 150) {
					jQuery(".js-leasing-radio").removeAttr("checked").prop("checked", false).change().attr("disabled", true).prop("disabled", true);
				}
				else {
					jQuery(".js-leasing-radio").removeAttr("disabled").removeProp("disabled");

				}
			});
		}
	});

}

var SearchVuePopup = null;
var LeasingVuePopup = null;

Popup.on("open", function(popup) {

	if (popup == "search") {

		SearchVuePopup = new Vue({
			el: ".popup"
		});
	}

	if (popup == "leasing") {

		LeasingVuePopup = new Vue({
			el: ".popup"
		});
	}

});

Popup.on("close", function(popup) {

	if (popup == "search") {
		SearchVuePopup.$destroy();
	}

	if (popup == "leasing") {
		LeasingVuePopup.$destroy();
	}
	
});

